"use client";

import { Tabs, TabsList, TabsTrigger } from "@/shared/ui/tabs";
import { useTranslations } from "next-intl";
import { useQueryStates } from "nuqs";
import { faqSearchParams } from "../lib/search-params";

const TABS = [
  {
    label: "f_fq_tab_1",
    value: "all",
  },
  {
    label: "f_fq_tab_2",
    value: "plan",
  },
  {
    label: "f_fq_tab_3",
    value: "account",
  },
  {
    label: "f_fq_tab_4",
    value: "software",
  },
  {
    label: "f_fq_tab_5",
    value: "support",
  },
  {
    label: "f_fq_tab_6",
    value: "etc",
  },
];

interface FaqNavigationProps {
  currentCategory: string;
}

export function FaqNavigation({ currentCategory }: FaqNavigationProps) {
  const t = useTranslations();
  const [, setParams] = useQueryStates(faqSearchParams, { shallow: false });

  const handleCategoryChange = (category: string) => {
    setParams({
      category,
      page: 1, // 카테고리 변경시 첫 페이지로
    });
  };

  return (
    <Tabs value={currentCategory} onValueChange={handleCategoryChange}>
      <TabsList className="tb:gap-y-3 tb:w-[537px] pc:w-auto flex h-auto flex-wrap items-center justify-start gap-x-2 gap-y-1 p-0">
        {TABS.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className="pc:cursor-pointer body-lg-medium data-[state=active]:bg-primary-500 tb:px-8 tb:py-3 pc:hover:bg-secondary-100 data-[state=active]:pc:hover:bg-primary-500 h-auto flex-0 rounded-[50px] bg-white px-4 py-[10px] text-gray-700 data-[state=active]:font-bold"
          >
            {t(tab.label)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
